import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { SectionCta } from './CtaButton';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-labelledby="ba-title" data-id="element-32" data-mp="3oezrhqjkjte7">
      <div className="mx-auto max-w-6xl" data-id="element-33" data-mp="3sgbju3ttusq3">
        <h2 id="ba-title" className="mx-auto max-w-3xl text-center text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-34" data-mp="3sjfu9ixvykp7">
          WHAT COULD CHANGE WHEN YOUR WORKFLOW IS BETTER ORGANIZED?
        </h2>

        <div className="mt-10 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr] md:gap-5" data-id="element-35" data-mp="34rs8tgje81ub">
          <div className="rounded-3xl border-2 border-danger/25 bg-[#FFF3F2] p-6 sm:p-8" data-id="element-36" data-mp="39qv6uh0yh7ss">
            <p className="text-sm font-black uppercase tracking-wide text-danger" data-id="element-37" data-mp="39oioi2racvf7">Before</p>
            <h3 className="mt-1 text-xl font-black text-ink sm:text-2xl" data-id="element-38" data-mp="2vtgbywrxo7tf">Disconnected resources</h3>
            <ul className="mt-6 space-y-4" data-id="element-39" data-mp="30rzzv2q37tof">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/80" data-id="element-40" data-mp="x6n3wd6ur7p9">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger text-white" data-id="element-41" data-mp="t2p5k4pcq0x9">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-42" data-mp="123n78gcbhwco" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-43" data-mp="9ezfq30z6aqo">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-cta text-white shadow-cta" data-id="element-44" data-mp="9d4wct5cqqop">
              <ArrowDownIcon className="h-6 w-6 md:hidden" strokeWidth={3} data-id="element-45" data-mp="jd5gghb1paty" />
              <ArrowRightIcon className="hidden h-6 w-6 md:block" strokeWidth={3} data-id="element-46" data-mp="jb2k7fjaulgs" />
            </span>
          </div>

          <div className="rounded-3xl bg-teal p-6 text-white sm:p-8" data-id="element-47" data-mp="3mtvspdx80k43">
            <p className="text-sm font-black uppercase tracking-wide text-gold" data-id="element-48" data-mp="3mtm49urtql0i">After</p>
            <h3 className="mt-1 text-xl font-black sm:text-2xl" data-id="element-49" data-mp="1qq7v1ettp3vv">A more structured approach</h3>
            <ul className="mt-6 space-y-4" data-id="element-50" data-mp="1vo9e3zr9137c">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-snug" data-id="element-51" data-mp="20hu4p6qiiuwi">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white text-teal" data-id="element-52" data-mp="24h2xo9dqaor0">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-53" data-mp="17tpuq90wrvo0" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-sm leading-relaxed text-muted" data-id="element-54" data-mp="1guwf4t6ohqmj">
          The resources support professional planning and do not replace individualized assessment, clinical judgment, or applicable professional standards.
        </p>
        <SectionCta label="I want the structured approach" data-id="element-55" data-mp="2x5idgy4opb3e" />
      </div>
    </section>;
}